import { trackEvent } from '@pm/analytics';
import { Icon, Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { usePatientProfile } from '../../hooks/profile';
import { labsRoutes } from '../../modules/labs/labs-routes';

export const LabSupport = () => {
  const { t } = useTranslation('labs', { keyPrefix: 'LabSupportHelp' });
  const { isUsaPatient } = usePatientProfile();

  const supportItems = [
    { route: labsRoutes.purpose.build(), textKey: 'Purpose' as const },
    ...(isUsaPatient
      ? [{ route: labsRoutes.meaning.build(), textKey: 'Meaning' as const }]
      : []),
    {
      route: labsRoutes.instructions.build(),
      textKey: 'Instructions' as const,
    },
  ];

  return (
    <section aria-label={t('Title')} className="space-y-xxs">
      <Text size="headingS" as="h2" color="contentSubdued">
        {t('Title')}
      </Text>
      <ul className="space-y-xxs">
        {supportItems.map((item, index) => (
          // eslint-disable-next-line react-x/no-array-index-key -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
          <li key={index} className="border-b border-default last:border-b-0">
            <Link
              to={item.route}
              className="flex justify-between items-center py-m cursor-pointer hover:bg-gray-50 transition-colors"
              onClick={() =>
                trackEvent('Button Clicked', {
                  buttonText: `${item.textKey} button clicked`,
                  buttonName: 'lab_support_link',
                  currentPageName: 'Lab Work',
                  currentPath: window.location.pathname,
                  targetPath: item.route,
                })
              }
            >
              <Text size="bodyL" color="contentSubdued">
                {t(item.textKey)}
              </Text>
              <Icon name="chevron_right" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
